<script lang="tsx">
import { computed, defineComponent, toRef } from 'vue'
import { createNamespace, deepClone } from '@bd/vue3-utils'
import { Table } from 'ant-design-vue'
import { AddBtn, DelBtn } from '-/Common/BdBtn'
import { Title } from '-/Common/Title'
import { tableFormProps } from './props'
const [name, bem] = createNamespace('TableForm')
export default defineComponent({
  name,
  props: tableFormProps,
  emits: ['add', 'del'],
  setup(props, { attrs, emit }) {
    const dataSource = toRef(props, 'dataSync')
    const headerCell = ({ column }) => <Title help={column?.help}>{column.title}</Title>

    const getDefaultValue = () => {
      return props.defaultData ? deepClone(props.defaultData) : {}
    }
    const handleAdd = () => {
      const defaultValue = getDefaultValue()
      if (props.useEvent) {
        emit('add', defaultValue)
        return
      }
      dataSource.value.push(defaultValue)
    }
    const handleDel = (index: number) => {
      if (props.useEvent) {
        emit('del', index)
        return
      }
      dataSource.value.splice(index, 1)
    }
    const renderAddBtn = (block = false) => (
      <AddBtn type={block ? 'dashed' : 'link'} disabled={props.addDisabled?.()} block={block} onClick={handleAdd} class={bem('add', { block })}>
        添加
      </AddBtn>
    )
    const renderActionCell = opt => <DelBtn type='link' disabled={props.delDisabled?.(opt)} danger onClick={() => handleDel(opt.index)} />
    const _columns = computed(() => {
      if (props.delVisible) {
        return props.columns.concat({
          title: '操作',
          dataIndex: 'action',
          width: 50,
          customRender: renderActionCell
        })
      }
      return props.columns
    })
    return () => (
      <div class={['ant-dynamic-form ant-dynamic-form--table', bem()]}>
        <Table
          size='small'
          pagination={false}
          dataSource={dataSource.value}
          columns={_columns.value}
          v-slots={{
            headerCell,
            emptyText: props.addVisible ? renderAddBtn : undefined
          }}
          {...attrs}
        />
        {props.addVisible && dataSource.value.length ? renderAddBtn(true) : null}
      </div>
    )
  }
})
</script>

<style scoped lang="less">
.table-form {
  :deep(.ant-input-number, .ant-input, .ant-select, .ant-input-affix-wrapper) {
    width: 100%;
  }

  &__add {
    &--block {
      margin-top: @margin-sm;
    }
  }
}
</style>
